import { type DriveFile } from '@/shared/DriveTypes';
import cx from 'classnames';
import { useState } from 'react';
import * as appStyles from '~/app.css';
import * as styles from './Page.css';

const getEmbedUrl = (file: DriveFile) => {
  const { webViewLink } = file;
  return webViewLink.replace(/\/edit(\?.+)?$/, '/edit?rm=embedded');
};

export const InlineEditor = ({ file }: { file: DriveFile }) => {
  const [loading, setLoading] = useState(true);
  const src = getEmbedUrl(file);

  const handleTransitionEnd = (e: React.TransitionEvent<HTMLDivElement>) => {
    if (e.propertyName === 'opacity' && !loading) {
      e.currentTarget.style.display = 'none';
    }
  };

  return (
    <div className={cx(styles.content, styles.inlineEditorContainer)}>
      <div
        className={cx(appStyles.fadeIn300, styles.inlineEditorLoadingBar)}
        style={{ opacity: loading ? 1 : 0 }}
        onTransitionEnd={handleTransitionEnd}
      />
      <div
        className={cx(appStyles.fadeIn300, styles.inlineEditorLoadingDoc)}
        style={{ height: loading ? '100%' : 0, opacity: loading ? 1 : 0 }}
        onTransitionEnd={handleTransitionEnd}
      >
        <div
          className={styles.inlineEditorLoadingDocInner}
          style={{ border: loading ? '1px solid #c7c7c7' : '1px solid transparent' }}
        />
      </div>
      <iframe
        tabIndex={-1}
        src={src}
        title={`Edit ${file.name}`}
        className={styles.inlineEditorIframe}
        style={{ opacity: loading ? 0 : 1 }}
        onLoad={() => {
          setLoading(false);
        }}
      />
    </div>
  );
};
